function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import SignInType from '@domain-group/fe-allhomes-library/lib/enums/sign-in-type';
import { AuthenticationError, WebserviceError } from './utils/exceptions';
import { MOBILE_V1, OLD_PUBLIC } from './utils/endpoints';
var clearUrl = () => {
  if (typeof window !== 'undefined') {
    var _window = window,
      location = _window.location,
      history = _window.history;
    var cleanUrl = "".concat(location.protocol, "//").concat(location.host).concat(location.pathname.replace('/activate', '/'));
    history.replaceState({}, document.title, cleanUrl);
  }
};
var Messages = {
  NEEDS_ACTIVATION: 'NEEDS_ACTIVATION',
  LOGIN_FAILED: 'LOGIN_FAILED',
  ERROR: 'ERROR',
  LOCKED: 'LOCKED'
};
export var AuthenticationState = {
  CLOSED: 'CLOSED',
  SIGN_IN: 'SIGN_IN',
  ACTIVATION: 'ACTIVATION',
  // Alias for SIGN_IN that sets SignInType to 'ACTIVATION'
  SIGN_UP: 'SIGN_UP',
  RETRIEVE_PASSWORD: 'RETRIEVE_PASSWORD',
  RESET_PASSWORD: 'RESET_PASSWORD',
  EU_PAGE: 'EU_PAGE'
};
var defaultState = {
  currentPage: AuthenticationState.CLOSED
};
var buildDefaultCurrentPage = initialAuthState => {
  switch (initialAuthState) {
    case AuthenticationState.ACTIVATION:
      return {
        currentPage: AuthenticationState.SIGN_IN,
        signInType: SignInType.ACTIVATION
      };
    default:
      return {
        currentPage: initialAuthState
      };
  }
};
var webserviceToIdentity = _ref => {
  var token = _ref.token,
    username = _ref.username,
    rentalWatchListListings = _ref.rentalWatchListListings,
    saleWatchListListings = _ref.saleWatchListListings,
    shareWatchListListings = _ref.shareWatchListListings,
    inspections = _ref.inspections,
    myAllHomesUserId = _ref.myAllHomesUserId;
  return {
    token,
    user: {
      email: username,
      type: 'authenticated',
      id: myAllHomesUserId
    },
    data: {
      watchlist: [...rentalWatchListListings, ...saleWatchListListings, ...shareWatchListListings],
      inspections
    }
  };
};
export default ((_ref2, updateContext) => {
  var shared = _ref2.shared,
    authToken = _ref2.authToken,
    initialAuthState = _ref2.initialAuthState,
    initialUsername = _ref2.initialUsername,
    _ref2$endpoints = _ref2.endpoints,
    endpoints = _ref2$endpoints === void 0 ? {} : _ref2$endpoints,
    reloadOnLogin = _ref2.reloadOnLogin;
  var getAbsoluteUrl = shared.getAbsoluteUrl,
    setLoadingState = shared.setLoadingState;
  var _endpoints$myahEndpoi = endpoints.myahEndpoint,
    myahEndpoint = _endpoints$myahEndpoi === void 0 ? "".concat(MOBILE_V1, "/myah") : _endpoints$myahEndpoi;
  var endpoint = action => "".concat(myahEndpoint, "/").concat(action);
  var _endpoints$signInEndp = endpoints.signInEndpoint,
    signInEndpoint = _endpoints$signInEndp === void 0 ? endpoint('login') : _endpoints$signInEndp,
    _endpoints$signUpEndp = endpoints.signUpEndpoint,
    signUpEndpoint = _endpoints$signUpEndp === void 0 ? endpoint('create') : _endpoints$signUpEndp,
    _endpoints$euUserEndp = endpoints.euUserEndpoint,
    euUserEndpoint = _endpoints$euUserEndp === void 0 ? endpoint('comms/optin') : _endpoints$euUserEndp,
    _endpoints$retrievePa = endpoints.retrievePasswordEndpoint,
    retrievePasswordEndpoint = _endpoints$retrievePa === void 0 ? endpoint('retupwd') : _endpoints$retrievePa,
    _endpoints$resetPassw = endpoints.resetPasswordEndpoint,
    resetPasswordEndpoint = _endpoints$resetPassw === void 0 ? endpoint('resetpwd') : _endpoints$resetPassw,
    _endpoints$resendActi = endpoints.resendActivationEndpoint,
    resendActivationEndpoint = _endpoints$resendActi === void 0 ? endpoint('request-activation-code') : _endpoints$resendActi,
    _endpoints$oldPublicM = endpoints.oldPublicMyahEndpoint,
    oldPublicMyahEndpoint = _endpoints$oldPublicM === void 0 ? "".concat(OLD_PUBLIC, "/myallhomes") : _endpoints$oldPublicM;
  var _shared$apiClient = shared.apiClient,
    terminate = _shared$apiClient.terminate,
    post = _shared$apiClient.post,
    get = _shared$apiClient.get,
    setIdentity = _shared$apiClient.setIdentity;
  var SIGN_IN = getAbsoluteUrl(signInEndpoint);
  var OLD_SIGN_IN = "".concat(getAbsoluteUrl(oldPublicMyahEndpoint), "/sign-in");
  var OLD_SIGN_OUT = "".concat(getAbsoluteUrl(oldPublicMyahEndpoint), "/signout");
  var SIGN_UP = getAbsoluteUrl(signUpEndpoint);
  var OPT_IN = getAbsoluteUrl(euUserEndpoint);
  var FORGOT = getAbsoluteUrl(retrievePasswordEndpoint);
  var RESET = getAbsoluteUrl(resetPasswordEndpoint);
  var RESEND_ACTIVATION = getAbsoluteUrl(resendActivationEndpoint);
  var MAX_SIGN_IN_COUNT = 5;
  if (initialAuthState) {
    clearUrl();
  }

  // For saving state between requests without pushing it through the context
  var state = {};
  var resetState = () => {
    state.signInData = {};
    state.signInCount = 0;
  };
  var resetSignInCallbacks = () => {
    state.onSignInCancel = undefined;
    state.onSignInSuccess = undefined;
  };
  resetState();
  var buildAuthenticationState = newState => prev => ({
    authentication: _objectSpread({
      actions: prev.authentication.actions
    }, typeof newState === 'function' ? newState(prev.authentication) : newState)
  });
  var updateAuthContext = newState => updateContext(buildAuthenticationState(newState));
  var switchPage = (newPage, additionalData) => {
    if (newPage === AuthenticationState.CLOSED && state.closeWithBack) {
      window.history.back();
    }
    return updateAuthContext(_objectSpread({
      currentPage: newPage,
      error: undefined
    }, additionalData));
  };
  var setCloseWithBack = () => {
    var action = window.history.state && window.history.state.dialogOpen ? 'replaceState' : 'pushState';
    window.history[action]({
      dialogOpen: true
    }, '');
    state.closeWithBack = true;
  };
  var openSignUp = () => {
    setCloseWithBack();
    switchPage(AuthenticationState.SIGN_UP);
  };

  /**
   * Opens the signIn dialog.
   * Takes a signInType object which contains a "title" and a "subtitle" value.
   * Defaults to "SignInType.SIGN_IN"
   *
   * This returns a promise with a value of "true" if the login succeeds,
   * or "false" if it's cancelled.
   */
  var openSignIn = signInType => new Promise(resolve => {
    var _signInType;
    // Check for the case where openSignIn has been passed directly to an event handler
    var isEvent = ((_signInType = signInType) === null || _signInType === void 0 ? void 0 : _signInType.nativeEvent) instanceof Event;
    setCloseWithBack();
    state.onSignInCancel = () => {
      resolve(false);
    };
    state.onSignInSuccess = () => {
      resolve(true);
    };

    /**
     * If `signInType` is anything other than one of `SignInType`s, such as
     * an object containing native event or a function
     * then default to `SignInType.SIGN_IN`.
     *
     * Or, if it is an object containing `type` containing a `SignInType`
     * then derive it from `signInType.type`.
     *
     * Otherwise, pass itself.
     */
    if (signInType && !isEvent && typeof signInType !== 'function') {
      var _signInType$type;
      signInType = (_signInType$type = signInType.type) !== null && _signInType$type !== void 0 && _signInType$type.type ? signInType.type : signInType; // eslint-disable-line no-param-reassign
    } else {
      signInType = SignInType.SIGN_IN; // eslint-disable-line no-param-reassign
    }
    switchPage(AuthenticationState.SIGN_IN, {
      signInType
    });
  });
  var closeAuth = () => {
    switchPage(AuthenticationState.CLOSED);
    try {
      var _state$onSignInCancel;
      (_state$onSignInCancel = state.onSignInCancel) === null || _state$onSignInCancel === void 0 ? void 0 : _state$onSignInCancel.call(state);
    } catch (_unused) {
      // do nothing
    }
    resetSignInCallbacks();
  };
  var setError = error => updateAuthContext(prev => _objectSpread(_objectSpread({}, prev), {}, {
    error
  }));
  var handleError = error => {
    setError([{
      errorCode: 99,
      message: error instanceof AuthenticationError ? error.message : Messages.ERROR
    }]);
  };
  var handleSignUpError = error => {
    if (error) {
      if (error instanceof WebserviceError && error.errorCode && error.errorCode === 'internal') {
        handleError(error);
      } else {
        setError(error.body ? Object.values(error.body) : Messages.ERROR);
      }
    } else {
      setError(Messages.ERROR);
    }
  };
  var handleResetPasswordError = error => {
    if (error.body) {
      setError(Object.values(error.body));
    } else {
      handleError(error);
    }
  };
  var reloadIfRequired = () => {
    if (reloadOnLogin) {
      window.location.reload(true);
    }
  };
  var doOldPublicLogin = (username, password) => post("".concat(OLD_SIGN_IN, "?src=").concat(window.location.href), {
    j_username: username,
    j_password: password
  }, {
    type: 'form'
  });
  var doOldPublicLogout = () => get(OLD_SIGN_OUT, null, {
    type: 'empty'
  });
  var signOut = () => {
    setLoadingState(true);
    terminate().then(() => {
      doOldPublicLogout().catch(() => {
        /* don't care if old logout fails */
      });
      reloadIfRequired();
    }).catch(error => {
      setLoadingState(false);
      throw error;
    });
  };
  var finishLogin = () => {
    setIdentity(webserviceToIdentity(state.signInData));
    updateContext(prev => buildAuthenticationState(defaultState)(prev));
    try {
      var _state$onSignInSucces;
      (_state$onSignInSucces = state.onSignInSuccess) === null || _state$onSignInSucces === void 0 ? void 0 : _state$onSignInSucces.call(state);
    } finally {
      resetSignInCallbacks();
      reloadIfRequired();
    }
  };
  var optIn = hasOptedIn => {
    var _state$signInData = state.signInData,
      token = _state$signInData.token,
      username = _state$signInData.username;
    return post(OPT_IN, {
      token,
      username,
      hasOptedIn
    }).then(() => {
      finishLogin();
    }).catch(handleError);
  };
  var signUp = signUpData => post(SIGN_UP, signUpData).then(() => {
    setError([]);
  }).catch(handleSignUpError);
  var signIn = (username, password) => {
    setLoadingState(true);
    return post(SIGN_IN, {
      username,
      password
    }).then(result => {
      setError([]);
      if (!result.token) {
        throw new AuthenticationError(Messages.ERROR);
      }
      resetState();
      state.signInData = _objectSpread(_objectSpread({}, result), {}, {
        username
      });
      doOldPublicLogin(username, password).catch(() => {
        /* Do Nothing */
      });
      if (result.showOptInPrompt) {
        switchPage(AuthenticationState.EU_PAGE);
      } else {
        finishLogin();
      }
    }).catch(error => {
      setLoadingState(false);
      if (error instanceof WebserviceError && error.errorCode === 400) {
        throw new AuthenticationError(Messages.NEEDS_ACTIVATION);
      }
      if (error instanceof WebserviceError && error.errorCode === 401) {
        state.signInCount += 1;
        throw new AuthenticationError(state.signInCount >= MAX_SIGN_IN_COUNT ? Messages.LOCKED : Messages.LOGIN_FAILED);
      }
      throw error;
    }).catch(error => {
      console.warn('Caught error logging in:', error); // eslint-disable-line no-console
      handleError(error);
    });
  };
  var retrievePassword = email => post(FORGOT, {
    email
  }).then(() => {
    setError([]);
  }).catch(err => {
    console.warn('caught error sending retrieve password link', err); // eslint-disable-line no-console
    handleError(err);
  });
  var resetPassword = (newPassword, otherParams) => post(RESET, _objectSpread({
    password: newPassword
  }, otherParams)).then(result => {
    setError([]);
    signIn(result.email, newPassword);
  }).catch(err => {
    console.warn('caught error sending reset password link', err); // eslint-disable-line no-console
    handleResetPasswordError(err);
  });
  var resendActivation = email => post(RESEND_ACTIVATION, email).then(() => {
    setError([]);
  }).catch(err => {
    console.warn('caught error resnending activation link', err); // eslint-disable-line no-console
    handleError(err);
  });
  if (typeof window !== 'undefined') {
    window.addEventListener('popstate', () => {
      if (state.closeWithBack) {
        state.closeWithBack = false;
        closeAuth();
      }
    });
  }
  return {
    openSignIn,
    openSignUp,
    signOut,
    closeAuth,
    authentication: _objectSpread(_objectSpread(_objectSpread({
      actions: {
        switchPage,
        signIn,
        signUp,
        optIn,
        retrievePassword,
        resetPassword,
        resendActivation,
        resetState
      }
    }, defaultState), buildDefaultCurrentPage(initialAuthState)), {}, {
      username: initialUsername,
      token: authToken
    })
  };
});